import React, { type FC, type ReactNode, type PropsWithChildren } from 'react';

import styled from '@emotion/styled';

import type { Lucid } from '../../../types/types';

interface LegendProps extends Partial<Lucid.Theme.Utility.Props> {
  /** The children to be rendered. */
  children?: ReactNode;
  /** Allows the component to get additional styles. */
  className?: string;
}

const StyledLegend = styled.legend<Partial<Lucid.Theme.Utility.Props>>(({ theme }) => ({
  label: 'marketoFormLegend',
  marginBottom: theme.space.s16,
  fontSize: theme.fontSizes.fs20,
  fontWeight: theme.fontWeights.fw500,
}));

const Legend: FC<PropsWithChildren<LegendProps>> = rest => <StyledLegend {...rest} />;

export default Legend;
